import { hot } from 'react-hot-loader/root'

import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { locationShape } from 'react-router'

import GuestEvent from 'containers/GuestEvent'
import MissingEvent from 'components/MissingEvent'
import LockedEvent from 'components/LockedEvent'
import LoadingScreen from 'components/LoadingScreen'

import {
  eventSelector,
  hostSelector
} from 'src/selectors'

import './styles.scss'

class App extends React.Component {
  _showMissingEvent () {
    const {
      showLoadingScreen,
      eventLoadingStatus
    } = this.props

    if (showLoadingScreen) { return false }

    const errorStatuses = ['error', 'destroyed', 'not_found']
    const eventError = errorStatuses.indexOf(eventLoadingStatus) > -1
    return eventError
  }

  _showLocked = () => this.props.event && !!this.props.event.locked_at

  _showEvent () {
    const {
      event,
      showLoadingScreen,
      invitationLoadingStatus,
      eventLoadingStatus
    } = this.props

    if (showLoadingScreen) { return false }

    const invitationLoaded = invitationLoadingStatus !== 'loading'
    return (eventLoadingStatus === 'success') && invitationLoaded && event
  }

  render () {
    const {
      host,
      event,
      eventLoadingStatus,
      location
    } = this.props

    if (this._showMissingEvent()) {
      return (
        <MissingEvent
          host={host}
          eventLoadingStatus={eventLoadingStatus}
        />
      )
    } else if (this._showLocked()) {
      return <LockedEvent
        event={event}
      />
    } else if (this._showEvent()) {
      return <GuestEvent location={location} />
    } else {
      return <LoadingScreen event={event} />
    }
  }
}

App.propTypes = {
  event: PropTypes.object,
  host: PropTypes.object,
  showLoadingScreen: PropTypes.bool,
  eventLoadingStatus: PropTypes.string.isRequired,
  invitationLoadingStatus: PropTypes.string.isRequired,
  location: locationShape
}

function mapStateToProps (state) {
  return {
    event: eventSelector(state),
    host: hostSelector(state),
    showLoadingScreen: state.frontend.showLoadingScreen,
    eventLoadingStatus: state.frontend.eventLoadingStatus,
    invitationLoadingStatus: state.frontend.invitationLoadingStatus
  }
}

export default connect(mapStateToProps)(hot(App))



// WEBPACK FOOTER //
// ./src/containers/App.jsx